import axios from 'axios'
import { baseURL } from "../settings/settings.js";
import { bus } from "../components/common/bus";


const axiosBase = async (method, data) => {
  try {
    let legalBrandResult = await axios.post(
      baseURL + method,
      data,
      {
        headers: {
        'Authorization': `Bearer ${localStorage.getItem("token")}`,
        'Source' : 'Web'
        }
      }
    )
    return legalBrandResult
  }
  catch(error)
  {
    if(error.response.status == "401"){
    window.location.replace("/");
    //console.log('redirect')
    }
    else  if(error.response.status == "403"){
     bus.$emit("warning", "თქვენ არ გაქვთ ამ მოქმედების შესრულების უფლება");
    }
    else{
      throw(error)
    }
  }
}

const getLegalBrand = async () => {
  let legalBrandResult = await axiosBase('legal/1.0/get-all-legal-brands');
  return legalBrandResult
}

const getLegalBrandCategories = async () => {
  let legalCategoriesResult = await axiosBase('legal/1.0/get-legal-brand-categories')
  return legalCategoriesResult
}

const postLegalBrand = async (data) => {
  let legalBrandAddResult = await axiosBase('files/1.0/legalbrand/add-legal-brand', data)
  return legalBrandAddResult
}

const putLegalBrand = async (data) => {
  let legalBrandEditResult = await axiosBase(
    'files/1.0/legalbrand/edit-legal-brand',
    data
  )
  return legalBrandEditResult
}

const deleteLegalBrand = async (legalBrandID) => {
  let legalBrandDeleteResult = await axiosBase(
    'legal/1.0/delete-legal-brand', {
      id: legalBrandID
    }
  )
  return legalBrandDeleteResult
}

const getByIDLegalBrand = async (legalBrandID) => {
  let legalBrandResult = await axiosBase(
    'legal/1.0/get-legal-brand', {
      id: legalBrandID
    }
  )
  return legalBrandResult
}

const postLegalBrancCategory = async (data) => {
  let legalBrancCategoryAddResult = await axiosBase(
    'legal/1.0/add-legal-brand-category',
    data
  )
  return legalBrancCategoryAddResult
}

const putLegalBrancCategory = async (data) => {
  let legalBrancCategoryEditResult = await axiosBase(
    'legal/1.0/edit-legal-brand-category',
    data
  )
  return legalBrancCategoryEditResult
}

const deleteLegalBrancCategory = async (legalBrancCategoryID) => {
  let legalBrancCategoryDeleteResult = await axiosBase(
    'legal/1.0/delete-legal-brand-category', {
      id: legalBrancCategoryID
    }
  )
  return legalBrancCategoryDeleteResult
}

const getByIDLegalBrancCategory = async (legalBrancCategoryID) => {
  let legalBrancCategoryResult = await axiosBase(
    'legal/1.0/get-legal-brand-category', {
      id: legalBrancCategoryID
    }
  )
  return legalBrancCategoryResult
}

const getLegalBrandMenuGroup = async () => {
  let legalMenuGroupResult = await axiosBase(
    'legal/1.0/get-legal-brand-menugroups', {}
  )
  return legalMenuGroupResult
}

const postLegalBrandMenuGroup = async (data) => {
  let legalMenuGroupAddResult = await axiosBase(
    'legal/1.0/add-legal-brand-menugroup',
    data
  )
  return legalMenuGroupAddResult
}

const putLegalBrandMenuGroup = async (data) => {
  let legalMenuGroupEditResult = await axiosBase(
    'legal/1.0/edit-legal-brand-menugroup',
    data
  )
  return legalMenuGroupEditResult
}

const deleteLegalBrandMenuGroup = async (legalBrandMenuGroupID) => {
  let legalMenuGroupDeleteResult = await axiosBase(
    'legal/1.0/delete-legal-brand-menugroup', {
      id: legalBrandMenuGroupID
    }
  )
  return legalMenuGroupDeleteResult
}

const getByIDLegalBrandMenuGroup = async (legalBrandMenuGroupID) => {
  let legalMenuGroupResult = await axiosBase(
    'legal/1.0/get-legal-brand-menugroup', {
      id: legalBrandMenuGroupID
    }
  )
  return legalMenuGroupResult
}

const getLottery = async () => {
  let lotteryResult = await axiosBase(
    'lottery/1.0/get-lotteries-for-back'
  )
  return lotteryResult
}

const postLottery = async (data) => {
  let lotteryAddResult = await axiosBase(
    'files/1.0/lottery/add-lottery',
    data
  )
  return lotteryAddResult
}

const putLottery = async (data) => {
  let LotteryEditResult = await axiosBase(
    'files/1.0/lottery/edit-lottery',
    data
  )
  return LotteryEditResult
}

const deleteLottery = async (lotteryID) => {
  let lotteryDeleteResult = await axiosBase(
    'lottery/1.0/delete-lottery', {
      id: lotteryID
    }
  )
  return lotteryDeleteResult
}

const getByIDLottery = async (lotteryID) => {
  let lotteryResult = await axiosBase(
    'lottery/1.0/get-lottery-by-id-for-back', {
      id: lotteryID
    }
  )
  return lotteryResult
}

const getLotteryMember = async () => {
  let lotteryMemberResult = await axiosBase(
    'lottery/1.0/get-all-lottery-members', {}
  )
  return lotteryMemberResult
}

const postLotteryMember = async (data) => {
  let lotteryMemberAddResult = await axiosBase(
    'lottery/1.0/add-lottery-member',
    data
  )
  return lotteryMemberAddResult
}

const putLotteryMember = async (data) => {
  let lotteryMemberEditResult = await axiosBase(
    'lottery/1.0/edit-lottery-member',
    data
  )
  return lotteryMemberEditResult
}

const deleteLotteryMember = async (lotteryMemberID) => {
  let lotteryMemberDeleteResult = await axiosBase(
    'lottery/1.0/delete-lottery-member', {
      id: lotteryMemberID
    }
  )
  return lotteryMemberDeleteResult
}

const getByIDLotteryMember = async (lotteryMemberID) => {
  let lotteryMemberResult = await axiosBase(
    'lottery/1.0/get-lottery-members-by-lottery-id', {
      id: lotteryMemberID
    }
  )
  return lotteryMemberResult
}

const postMerchant = async (data) => {
  let merchantAddResult = await axiosBase(
    'merchant/1.0/add-merchant',
    data
  )
  return merchantAddResult
}

const putMerchant = async (data) => {
  let merchantEditResult = await axiosBase(
    'merchant/1.0/edit-merchant',
    data
  )
  return merchantEditResult
}

const getMerchant = async () => {
  let merchantResult = await axiosBase(
    'merchant/1.0/get-all-merchants', {}
  )
  return merchantResult
}

const getByIDMerchant = async (merchantID) => {
  let merchantResult = await axiosBase(
    'merchant/1.0/get-merchant', {
      id: merchantID
    }
  )
  return merchantResult
}

const deleteMerchant = async (merchantID) => {
  let merchantDeleteResult = await axiosBase(
    'merchant/1.0/delete-merchant', {
      id: merchantID
    }
  )
  return merchantDeleteResult
}

const getLegal = async () => {
  let legalResult = await axiosBase(
    'legal/1.0/get-legals'
  )
  return legalResult
}

const postLegal = async (data) => {
  let organizationAddResult = await axiosBase(
    'legal/1.0/add-legal',
    data
  )
  return organizationAddResult
}

const putLegal = async (data) => {
  let organizationEditResult = await axiosBase(
    'legal/1.0/edit-legal',
    data
  )
  return organizationEditResult
}

const deleteLegal = async (legalID) => {
  let organizationDeleteResult = await axiosBase(
    'legal/1.0/delete-legal', {
      id: legalID
    }
  )
  return organizationDeleteResult
}

const getByIDLegal = async (legalID) => {
  let legalResult = await axiosBase(
    'legal/1.0/get-legal', {
      id: legalID
    }
  )
  return legalResult
}

const getProductBrand = async () => {
  let productBrandResult = await axiosBase(
    'prod/1.0/get-all-product-brands'
  )
  return productBrandResult
}

const postProductBrand = async (data) => {
  let productBrandObjectAdd = await axiosBase(
    'files/1.0/prod/add-brand',
    data
  )
  return productBrandObjectAdd
}

const putProductBrand = async (data) => {
  let productBrandEditResult = await axiosBase(
    'files/1.0/prod/edit-brand',
    data
  )
  return productBrandEditResult
}

const deleteProductBrand = async (productBrandID) => {
  let productPropertyDeleteResult = await axiosBase(
    'prod/1.0/delete-product-brand', {
      id: productBrandID
    }
  )
  return productPropertyDeleteResult
}

const getByIDProductBrand = async (productBrandID) => {
  let productBrandResult = await axiosBase(
    'prod/1.0/get-product-brand', {
      id: productBrandID
    }
  )
  return productBrandResult
}

const getProductCategory = async () => {
  let productCategoryResult = await axiosBase(
    'prod/1.0/get-all-prod-categories-full'
  )
  return productCategoryResult
}

const postProductCategory = async (data) => {
  let productCategoryAddResult = await axiosBase(
    'prod/1.0/add-prod-category',
    data
  )
  return productCategoryAddResult
}

const putProductCategory = async (data) => {
  let productCategoryEditResult = await axiosBase(
    'prod/1.0/edit-prod-category',
    data
  )
  return productCategoryEditResult
}

const deleteProductCategory = async (productCategoryID) => {
  let productCategoryDeleteResult = await axiosBase(
    'prod/1.0/delete-prod-category', {
      id: productCategoryID
    }
  )
  return productCategoryDeleteResult
}

const getByIDProductCategory = async (productCategoryID) => {
  let productCategoryResult = await axiosBase(
    'prod/1.0/get-prod-category', {
      id: productCategoryID
    }
  )
  return productCategoryResult
}

const getProductLoyaltyPrize = async () => {
  let productLoyaltyPrizeResult = await axiosBase(
    'prod-loyalty/1.0/get-all-event-prizes'
  )
  return productLoyaltyPrizeResult
}

const postProductLoyaltyPrize = async (data) => {
  let productLoyaltyPrizeAddResult = await axiosBase(
    'files/1.0/loyalty/add-event-prize',
    data
  )
  return productLoyaltyPrizeAddResult
}

// const deleteProductLoyaltyPrize = async (productLoyaltyPrizeID) => {
//   let productLoyaltyPrizeDeleteResult = await axiosBase(
//     'api/lottery/1.0/delete-lottery-prize',
//     { id: this.productLoyaltyPrizeID }
//   )
//   return productLoyaltyPrizeDeleteResult
// }

const getProductMenuGroup = async () => {
  let productMenuGroupResult = await axiosBase(
    'prod/1.0/get-all-product-menu-groups'
  )
  return productMenuGroupResult
}

const postProductMenuGroup = async (data) => {
  let productMenuGroupAddResult = await axiosBase(
    'prod/1.0/add-product-menu-group',
    data
  )
  return productMenuGroupAddResult
}

const putProductMenuGroup = async (data) => {
  let productMenuGroupEditResult = await axiosBase(
    'prod/1.0/edit-product-menu-group',
    data
  )
  return productMenuGroupEditResult
}

const deleteProductMenuGroup = async (productMenuGroupID) => {
  let productMenuGroupDeleteResult = await axiosBase(
    'prod/1.0/delete-product-menu-group', {
      id: productMenuGroupID
    }
  )
  return productMenuGroupDeleteResult
}

const getByIDProductMenuGroup = async (productMenuGroupID) => {
  let productMenuGroupById = await axiosBase(
    'prod/1.0/get-product-menu-group', {
      id: productMenuGroupID
    }
  )
  return productMenuGroupById
}

const getProduct = async () => {
  let productResult = await axiosBase(
    'prod/1.0/get-products'
  )
  return productResult
}



const postProduct = async (data) => {
  let productAddResult = await axiosBase(
    'files/1.0/prod/add-product',
    data
  )
  return productAddResult
}

const putProduct = async (data) => {
  let productEditResult = await axiosBase(
    'files/1.0/prod/edit-product',
    data
  )
  return productEditResult
}

const deleteProduct = async (productID) => {
  let productDeleteResult = await axiosBase(
    'prod/1.0/delete-product', {
      id: productID
    }
  )
  return productDeleteResult
}

const getByIDProduct = async (productID) => {
  let productResult = await axiosBase(
    'prod/1.0/get-product', {
      id: productID
    }
  )
  return productResult
}

const getByIDProductGallery = async (productID) => {
  let getByIDProductGalleryResult = await axiosBase(
    'prod/1.0/get-product-gallery', {
      id: productID
    }
  )
  return getByIDProductGalleryResult
}

const getByIDProductWithGallery = async (productID) => {
  let productResultWithGallery = await axiosBase(
    'prod/1.0/get-product-with-gallery', {
      id: productID
    }
  )
  return productResultWithGallery
}

const getProductSubCategory = async (data) => {
  let productSubCategoryResult = await axiosBase(
    'prod/1.0/get-all-prod-sub-categories',
    data
  )
  return productSubCategoryResult
}

const postProductSubCategory = async (data) => {
  let productSubCategoryAddResult = await axiosBase(
    'prod/1.0/add-prod-sub-category',
    data
  )
  return productSubCategoryAddResult
}

const putProductSubCategory = async (data) => {
  let productSubCategoryEditResult = await axiosBase(
    'prod/1.0/edit-prod-sub-category',
    data
  )
  return productSubCategoryEditResult
}

const deleteProductSubCategory = async (productSubCategoryID) => {
  let productSubCategoryDeleteResult = await axiosBase(
    'prod/1.0/delete-prod-sub-category', {
      id: productSubCategoryID
    }
  )
  return productSubCategoryDeleteResult
}

const getByIDProductSubCategory = async (productCategoryID) => {
  let productSubCategoryResult = await axiosBase(
    'prod/1.0/get-all-prod-sub-categories-full', {
      id: productCategoryID
    }
  )
  return productSubCategoryResult
}

const getProductSubSubCategory = async (data) => {
  let productSubSubCategoryResult = await axiosBase(
    'prod/1.0/get-all-prod-sub-categories-2',
    data
  )
  return productSubSubCategoryResult
}

const postProductSubSubCategory = async (data) => {
  let productSubSubCategoryAddResult = await axiosBase(
    'prod/1.0/add-prod-sub-category-2',
    data
  )
  return productSubSubCategoryAddResult
}

const putProductSubSubCategory = async (data) => {
  let productSubSubCategoryEditResult = await axiosBase(
    'prod/1.0/edit-prod-sub-category-2',
    data
  )
  return productSubSubCategoryEditResult
}

const deleteProductSubSubCategory = async (productSubSubCategoryID) => {
  let productSubSubCategoryDeleteResult = await axiosBase(
    'prod/1.0/delete-prod-sub-category-2', {
      id: productSubSubCategoryID
    }
  )
  return productSubSubCategoryDeleteResult
}

const getByIDProductSubSubCategory = async (productSubCategoryID) => {
  let productSubSubCategoryResult = await axiosBase(
    'prod/1.0/get-all-prod-sub-categories-2-full', {
      id: productSubCategoryID
    }
  )
  return productSubSubCategoryResult
}

const getProductProperty = async () => {
  let productPropertyResult = await axiosBase(
    'prod/1.0/get-all-prod-properties-full'
  )
  return productPropertyResult
}

const postProductProperty = async (data) => {
  let productPropertyAddResult = await axiosBase(
    'prod/1.0/add-prod-property',
    data
  )
  return productPropertyAddResult
}

const putProductProperty = async (data) => {
  let productPropertyEditResult = await axiosBase(
    'prod/1.0/edit-prod-property',
    data
  )
  return productPropertyEditResult
}

const deleteProductProperty = async (productPropertyID) => {
  let productPropertyDeleteResult = await axiosBase(
    'prod/1.0/delete-prod-property', {
      id: productPropertyID
    }
  )
  return productPropertyDeleteResult
}

const getByIDProductProperty = async (productPropertyID) => {
  let productPropertyResult = await axiosBase(
    'prod/1.0/get-prod-property', {
      id: productPropertyID
    }
  )
  return productPropertyResult
}

const getProductSale = async () => {
  let productSaleResult = await axiosBase(
    'prod/1.0/get-prod-sales'
  )
  return productSaleResult
}

const postProductSale = async (data) => {
  let productSaleAddResult = await axiosBase(
    'prod/1.0/add-prod-sale',
    data
  )
  return productSaleAddResult
}

const putProductSale = async (data) => {
  let productSaleEditResult = await axiosBase(
    'prod/1.0/edit-prod-sale',
    data
  )
  return productSaleEditResult
}

const deleteProductSale = async (productSaleID) => {
  let productSaleDeleteResult = await axiosBase(
    'prod/1.0/delete-prod-sale-by-id', {
      id: productSaleID
    }
  )
  return productSaleDeleteResult
}

const getByIDProductSale = async (productSaleID) => {
  let productSaleResult = await axiosBase(
    'prod/1.0/get-prod-sale-by-id', {
      id: productSaleID
    }
  )
  return productSaleResult
}

const getSpecialGroup = async () => {
  let specialGroupResult = await axiosBase(
    'legal/1.0/get-special-groups'
  )
  return specialGroupResult
}

const postSpecialGroup = async (data) => {
  let specialGroupAddResult = await axiosBase(
    'legal/1.0/add-special-group',
    data
  )
  return specialGroupAddResult
}

const putSpecialGroup = async (data) => {
  let specialGroupEditResult = await axiosBase(
    'legal/1.0/edit-special-group',
    data
  )
  return specialGroupEditResult
}

const deleteSpecialGroup = async (specialGroupID) => {
  let specialGroupDeleteResult = await axiosBase(
    'legal/1.0/delete-special-group', {
      id: specialGroupID
    }
  )
  return specialGroupDeleteResult
}

const getByIDSpecialGroup = async (specialGroupID) => {
  let specialGroupResult = await axiosBase(
    'legal/1.0/get-special-group', {
      id: specialGroupID
    }
  )
  return specialGroupResult
}

const getSpecialItem = async () => {
  let specialItemResult = await axiosBase(
    'legal/1.0/get-special-items'
  )
  return specialItemResult
}

const postSpecialItem = async (data) => {
  let productCategoryAddResult = await axiosBase(
    'files/1.0/special/add-special-item',
    data
  )
  return productCategoryAddResult
}

const putSpecialItem = async (data) => {
  let specialItemEditResult = await axiosBase(
    'files/1.0/special/edit-special-item',
    data
  )
  return specialItemEditResult
}

const deleteSpecialItem = async (specialItemID) => {
  let productCategoryDeleteResult = await axiosBase(
    'legal/1.0/delete-special-item', {
      id: specialItemID
    }
  )
  return productCategoryDeleteResult
}

const getByIDSpecialItem = async (specialItemID) => {
  let specialItemResult = await axiosBase(
    'legal/1.0/get-special-item', {
      id: specialItemID
    }
  )
  return specialItemResult
}

const postCashierLoyalty = async (data) => {
  let cashierLoyaltyAddResult = await axiosBase(
    'cashierLoyalty/1.0/add-cashierLoyalty',
    data
  )
  return cashierLoyaltyAddResult
}

const getCashierLoyalties = async () => {
  let cashierLoyaltiesResult = await axiosBase(
    'cashierLoyalty/1.0/get-cashierLoyalties', {}
  )
  return cashierLoyaltiesResult
}

const putCashierLoyalty = async (data) => {
  let cashierLoyaltyEditResult = await axiosBase(
    'cashierLoyalty/1.0/edit-cashierLoyalty',
    data
  )
  return cashierLoyaltyEditResult
}

const postMerchantCashierLoyalty = async (data) => {
  let merchantCashierLoyaltyAddResult = await axiosBase(
    'cashierLoyalty/1.0/add-merchantCashierLoyalty',
    data
  )
  return merchantCashierLoyaltyAddResult
}

const getMerchantCashierLoyaltiesByMerchantId = async (data) => {
  let merchantCashierLoyaltiesResult = await axiosBase(
    'cashierLoyalty/1.0/get-merchantCashierLoyalty', {id:data}
  )
  return merchantCashierLoyaltiesResult
}

const putMerchantCashierLoyalty = async (data) => {
  let merchantCashierLoyaltyEditResult = await axiosBase(
    'cashierLoyalty/1.0/edit-merchantCashierLoyalty',
    data
  )
  return merchantCashierLoyaltyEditResult
}

const postProductLoyalty = async (data) => {
  let productLoyaltyAddResult = await axiosBase(
    'prod-loyalty/1.0/add-productLoyalty',
    data
  )
  return productLoyaltyAddResult
}

const getProductLoyalties = async () => {
  let productLoyaltiesResult = await axiosBase(
    'prod-loyalty/1.0/get-productLoyalties', {}
  )
  return productLoyaltiesResult
}

const putProductLoyalty = async (data) => {
  let productLoyaltyEditResult = await axiosBase(
    'prod-loyalty/1.0/edit-productLoyalty',
    data
  )
  return productLoyaltyEditResult
}

const addProductGalleryImage = async (data) => {
  let addProductGalleryImageResult = await axiosBase(
    'files/1.0/prod/add-product-image',
    data
  )
  return addProductGalleryImageResult
}

const deleteProductGalleryImage = async (data) => {
  let deleteProductGalleryImageResult = await axiosBase(
    'prod/1.0/delete-product-image',
    data
  )
  return deleteProductGalleryImageResult
}

const changeProductMainImage = async (data) => {
  let changeProductMainImageResult = await axiosBase(
    'files/1.0/prod/change-product-main-image',
    data
  )
  return changeProductMainImageResult
}

const deleteProductCategoryDetail = async (id) => {
  let deleteProductCategoryDetailResult = await axiosBase(
    'prod/1.0/delete-product-category', {
      id: id
    }
  )
  return deleteProductCategoryDetailResult
}

const addProductCategoryDetail = async (data) => {
  let addProductCategoryDetailResult = await axiosBase(
    'prod/1.0/add-product-category',
     data

  )
  return addProductCategoryDetailResult
}

const login = async (data) => {
  let loginResult = await axiosBase(
    'boffice/1.0/login',
     data

  )
  return loginResult
}

const geRolePermissions = async (data) => {
  let result = await axiosBase(
    'boffice/1.0/get-role-permissions',
     data
  )
  return result
}

const editRolePermissions = async (data) => {
  let result = await axiosBase(
    'boffice/1.0/change-role-permissions',
     data
  )
  return result
}

const getUsers = async (data) => {
  let result = await axiosBase(
    'boffice/1.0/get-users'
  )
  return result
}

const getRoles = async (data) => {
  let result = await axiosBase(
    'boffice/1.0/get-roles'
  )
  return result
}

const editUser = async (data) => {
  let result = await axiosBase(
    'boffice/1.0/edit-user',
    data
  )
  return result
}

const addUser = async (data) => {
  let result = await axiosBase(
    'boffice/1.0/add-user',
    data
  )
  return result
}

const addRole = async (data) => {
  let result = await axiosBase(
    'boffice/1.0/add-role',
    data
  )
  return result
}

const changePass = async (data) => {
  let result = await axiosBase(
    'boffice/1.0/change-password',
    data
  )
  return result
}

const getAppAccounts = async (data) => {
  let result = await axiosBase(
    'acc-management/1.0/get-accounts',
    data
  )
  return result
}

const deleteAppAccounts = async (data) => {
  let result = await axiosBase(
    'acc-management/1.0/delete-account',
    data
  )
  return result
}

const resetPassStep1 = async (data) => {
  let result = await axiosBase(
    'boffice/1.0/reset-password-step1',
    data
  )
  return result
}

const resetPassStep2 = async (data) => {
  let result = await axiosBase(
    'boffice/1.0/reset-password-step2',
    data
  )
  return result
}

const qrDeserialize = async (data) => {
  let result = await axiosBase(
    'acc-management/1.0/qr-deserialize',    {
    qr:data}
  )
  return result
}

const qrSerialize = async (data) => {
  let result = await axiosBase(
    'acc-management/1.0/qr-serialize',
   data
  )
  return result
}

const getCardLoyaltyOrganizations = async (data) => {
  let result = await axiosBase(
    'card-loyalty-backOffice/1.0/get-cardLoyaltyOrganizations',
    data
  )
  return result
}

const addCardLoyaltyOrganization = async (data) => {
  let result = await axiosBase(
    'card-loyalty-backOffice/1.0/add-cardLoyaltyOrganization',
    data
  )
  return result
}

const editCardLoyaltyOrganization = async (data) => {
  let result = await axiosBase(
    'card-loyalty-backOffice/1.0/edit-cardLoyaltyOrganization',
    data
  )
  return result
}

const deleteCardLoyaltyOrganization = async (data) => {
  let result = await axiosBase(
    'card-loyalty-backOffice/1.0/delete-cardLoyaltyOrganization',
    {id:data}
  )
  return result
}

const getCardLoyaltyOrganization = async (data) => {
  let result = await axiosBase(
    'card-loyalty-backOffice/1.0/get-cardLoyaltyOrganization',
    { id: data}
  )
  return result
}

const getNewApplications = async (data) => {
  let result = await axiosBase(
    'applications/1.0/get-new-applications'
  )
  return result
}

const rejectApplication = async (data) => {
  let result = await axiosBase(
    'applications/1.0/reject-application',
    {accountId:data}
  )
  return result
}

const approveApplication = async (data) => {
  let result = await axiosBase(
    'applications/1.0/approve-application',
    {accountId:data}
  )
  return result
}

const getFinishedApplications = async (data) => {
  let result = await axiosBase(
    'applications/1.0/get-finished-applications'
  )
  return result
}

const addApplicationDocument = async (data) => {
  let result = await axiosBase(
    'files/1.0/prod/add-application-document',
    data
  )
  return result
}

const deleteApplicationDocument = async (data) => {
  let result = await axiosBase(
    'applications/1.0/delete-application-documnet',
    data
  )
  return result
}

const sendAccountApplicationSMSCode = async (data) => {
  let result = await axiosBase(
    'applications/1.0/send-sms-code',
    data
  )
  return result
}

const editApplication = async (data) => {
  let result = await axiosBase(
    'applications/1.0/edit-application',
    data
  )
  return result
}

const getMenuItems = async (data) => {
  let result = await axiosBase(
    'boffice/1.0/get-menu-items'
  )
  return result
}

const getPartners = async (data) => {
  let result = await axiosBase(
    'boffice/1.0/get-partner-organizations'
  )
  return result
}

const addPartner = async (data) => {
  let result = await axiosBase(
    'boffice/1.0/add-partner-organization',
    data
  )
  return result
}

const editPartner = async (data) => {
  let result = await axiosBase(
    'boffice/1.0/edit-partner-organization',
    data
  )
  return result
}

const deletePartner = async (data) => {
  let result = await axiosBase(
    'boffice/1.0/delete-partner-organization',
    data
  )
  return result
}

const getChargeOperations = async (data) => {
  let result = await axiosBase(
    'boffice/1.0/get-charge-operations'
  )
  return result
}

const addChargeOperation = async (data) => {
  let result = await axiosBase(
    'boffice/1.0/add-charge-operation',
    data
  )
  return result
}

const getUserPoints = async (data) => {
  let result = await axiosBase(
    'boffice/1.0/get-user-points',
    data
  )
  return result
}

const addPoints = async (data) => {
  let result = await axiosBase(
    'boffice/1.0/add-points',
    data
  )
  return result
}

const getUserTotalPoints = async (data) => {
  let result = await axiosBase(
    'boffice/1.0/get-user-total-points',
    data
  )
  return result
}

const deleteUserOperations = async (data) => {
  let result = await axiosBase(
    'boffice/1.0/delete-user-operations',
    data
  )
  return result
}

const changePartnerImage = async (data) => {
  let result = await axiosBase(
    'files/1.0/prod/change-partner-image',
    data
  )
  return result
}

const deletePartnerCategory = async (partnerCategoryId) => {
  let merchantDeleteResult = await axiosBase(
    'boffice/1.0/delete-partner-category', {
      partnerCategoryId: partnerCategoryId
    }
  )
  return merchantDeleteResult
}

const addPartnerCategory = async (data) => {
  let result = await axiosBase(
    'boffice/1.0/add-partner-category',
      data
  )
  return result
}

const getProcurementApplications = async (data) => {
  let result = await axiosBase(
    'boffice/1.0/get-procurement-applications',
    data
  )
  return result
}

const proccessProcurementApplication = async (data) => {
  let result = await axiosBase(
    'boffice/1.0/proccess-procurement-application',
    data
  )
  return result
}

const editProcurementApplication = async (data) => {
  let result = await axiosBase(
    'boffice/1.0/edit-procurement-application',
    data
  )
  return result
}

const getPartnersInfo = async (data) => {
  let result = await axiosBase(
    'api/partner-info/1.0/get-all'
  )
  return result
}

const createPartnerInfo = async (data) => {
  let result = await axiosBase(
    'api/partner-info/1.0/create',
    data
  )
  return result
}

const updatePartnerInfo = async (data) => {
  let result = await axiosBase(
    'api/partner-info/1.0/update',
    data
  )
  return result
}

const deletePartnerInfo = async (data) => {
  let result = await axiosBase(
    'api/partner-info/1.0/delete',
    data
  )
  return result
}

export default {
  getLegalBrand,
  getLegalBrandCategories,
  postLegalBrand,
  putLegalBrand,
  deleteLegalBrand,
  getByIDLegalBrand,
  postLegalBrancCategory,
  putLegalBrancCategory,
  deleteLegalBrancCategory,
  getByIDLegalBrancCategory,
  getLegalBrandMenuGroup,
  postLegalBrandMenuGroup,
  putLegalBrandMenuGroup,
  deleteLegalBrandMenuGroup,
  getByIDLegalBrandMenuGroup,
  getLottery,
  postLottery,
  putLottery,
  deleteLottery,
  getByIDLottery,
  getLotteryMember,
  postLotteryMember,
  putLotteryMember,
  deleteLotteryMember,
  getByIDLotteryMember,
  getMerchant,
  postMerchant,
  putMerchant,
  getByIDMerchant,
  getLegal,
  postLegal,
  putLegal,
  deleteLegal,
  getByIDLegal,
  getProductBrand,
  postProductBrand,
  putProductBrand,
  deleteProductBrand,
  getByIDProductBrand,
  getProductCategory,
  postProductCategory,
  putProductCategory,
  deleteProductCategory,
  getByIDProductCategory,
  getProductLoyaltyPrize,
  postProductLoyaltyPrize,
  getProductMenuGroup,
  postProductMenuGroup,
  putProductMenuGroup,
  deleteProductMenuGroup,
  getByIDProductMenuGroup,
  getProduct,
  postProduct,
  putProduct,
  deleteProduct,
  getByIDProduct,
  getByIDProductWithGallery,
  getProductSubCategory,
  postProductSubCategory,
  putProductSubCategory,
  deleteProductSubCategory,
  getByIDProductSubCategory,
  getProductSubSubCategory,
  postProductSubSubCategory,
  putProductSubSubCategory,
  deleteProductSubSubCategory,
  getByIDProductSubSubCategory,
  getProductProperty,
  postProductProperty,
  putProductProperty,
  deleteProductProperty,
  getByIDProductProperty,
  getProductSale,
  postProductSale,
  putProductSale,
  deleteProductSale,
  getByIDProductSale,
  getSpecialGroup,
  postSpecialGroup,
  putSpecialGroup,
  deleteSpecialGroup,
  getByIDSpecialGroup,
  getSpecialItem,
  postSpecialItem,
  putSpecialItem,
  deleteSpecialItem,
  getByIDSpecialItem,
  deleteMerchant,
  postCashierLoyalty,
  getCashierLoyalties,
  putCashierLoyalty,
  postMerchantCashierLoyalty,
  getMerchantCashierLoyaltiesByMerchantId,
  putMerchantCashierLoyalty,
  postProductLoyalty,
  getProductLoyalties,
  putProductLoyalty,
  addProductGalleryImage,
  deleteProductGalleryImage,
  getByIDProductGallery,
  changeProductMainImage,
  deleteProductCategoryDetail,
  addProductCategoryDetail,
  login,
  geRolePermissions,
  editRolePermissions,
  getUsers,
  getRoles,
  editUser,
  changePass,
  getAppAccounts,
  deleteAppAccounts,
  resetPassStep1,
  resetPassStep2,
  addUser,
  addRole,
  qrDeserialize,
  qrSerialize,
  getCardLoyaltyOrganizations,
  addCardLoyaltyOrganization,
  editCardLoyaltyOrganization,
  deleteCardLoyaltyOrganization,
  getCardLoyaltyOrganization,
  getNewApplications,
  rejectApplication,
  approveApplication,
  getFinishedApplications,
  addApplicationDocument,
  deleteApplicationDocument,
  sendAccountApplicationSMSCode,
  editApplication,
  getMenuItems,
  getPartners,
  addPartner,
  editPartner,
  deletePartner,
  getChargeOperations,
  addChargeOperation,
  getUserPoints,
  addPoints,
  getUserTotalPoints,
  deleteUserOperations,
  changePartnerImage,
  deletePartnerCategory,
  addPartnerCategory,
  getProcurementApplications,
  proccessProcurementApplication,
  editProcurementApplication,
  getPartnersInfo,
  createPartnerInfo,
  updatePartnerInfo,
  deletePartnerInfo
}



// WEBPACK FOOTER //
// ./src/webAPI/callAPI.js